export const getStyles = (theme: any) => ({
  styles: {
    textField: {
      width: "180px",
      input: {
        color: theme.palette.grey[700],
      },

      "&:hover": { height: "auto" },
      "& .MuiInputBase-input": {
        padding: 0,
      },
    },
  },
});
